import Location from 'react-app-location';

export const NewRequestsLocation = new Location('/requests/new');
